define('formkit/view/form.object/base.form.object.view',['require','exports','module','underscore','./content/base.content.view','./common/base.form.object.top.view','../../state/form.object.state','bluebird','backbone.radio','../../templates','uikit/uikit'],function(require, exports, module){
  var _                     = require('underscore');
  var BaseContentView       = require('./content/base.content.view');
  var BaseFormObjectTopView = require('./common/base.form.object.top.view');
  var FormObjectState       = require('../../state/form.object.state');
  var Promise               = require('bluebird');
  var Radio                 = require('backbone.radio');
  var Templates             = require('../../templates');
  var UIKit                 = require('uikit/uikit');


  var FormObjectView = UIKit.ItemView.extend({

    className: 'ui formObject',

    template: Templates.App['base.form.object'],

    options: {
      readonly: false,
      disableLabelAndDescriptionInputFields: false,
      formObjectStateClass: FormObjectState
    },

    attributes: function() {
      return {
        'data-id' : this.model ? this.model.id : null
      }
    },

    internalViewBindings: {
      contentView: {
        readonly: 'readonly'
      }
    },

    internalViewOptions: {
      topView: function() {
        return _.extend({
          type: BaseFormObjectTopView,
          form: this.form,
          model: this.model,
          formObjectState: this.getFormObjectState()
        }, Mn._getValue(this.getOption('top'), this), {})
      },
      contentView: function() {
        return {
          type: this.getFormObjectContentViewType(),
          form: this.form,
          model: this.model,
          readonly: this.getOption('readonly'),
          comparing: this.getOption('comparing'),
          disableLabelAndDescriptionInputFields: this.getOption('disableLabelAndDescriptionInputFields'),
          isTargetable: this.form.isTemplateObjectTargetable(this.model),
          formObjectState: this.getFormObjectState()
        }
      },
      bottomView: function() {
        return _.extend({
          className: 'ui segment',
          form: this.form,
          model: this.model,
          readonly: this.getOption('readonly'),
          comparing: this.getOption('comparing'),
          formObjectState: this.getFormObjectState()
        }, Mn._getValue(this.getOption('bottom'), this), {})
      }
    },

    initialize: function() {
      UIKit.ItemView.prototype.initialize.apply(this, arguments);
      if (this.getOption('form')) {
        this.getOption('form').registerFormObjectView(this.model.id, this);
      }
      this.$el.data('formObjectView', this);
    },

    getFormObjectState: function() {
      if (!this.formObjectState) {
        var formObjectStateClass = this.getOption('formObjectStateClass') || FormObjectState; 
        this.formObjectState = new formObjectStateClass(this.getFormObjectStateDefaults(), {
          templateObjectModel: this.model,
          form: this.form
        });
      }
      return this.formObjectState;
    },

    getFormObjectStateDefaults: function() {
      return Mn._getValue(this.formObjectStateDefaults, this);
    },

    getFormObjectContentViewType: function () {
      var ContentView;
      if (!this.form) {
        var message = 'Error getting template object content view type. Base form object view instance has no form.';
        Promise.reject(new Error(message));
        ContentView = BaseContentView.extend({ template: false });
      }
      else {
        ContentView = this.form.getContentView(this.form.getTemplateObjectTypeName(this.model));
      }

      return ContentView;
    }

  });

  module.exports = FormObjectView;

});

